import { isEmpty } from 'lodash';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, UrlTree, UrlSegment, ActivatedRoute, RouterStateSnapshot } from '@angular/router';

interface IDriverProfileV2AccessGuard {
  shouldAllow: boolean,
  redirectTo?: string,
}

@Injectable()
export class DriverProfileV2AccessGuard implements CanActivate {
  constructor(
    private router: Router,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const config: IDriverProfileV2AccessGuard = route.data?.driverProfileV2AccessGuard;
    const shouldAllowAccess: boolean = config.shouldAllow;
    let driverId: number;

    if (shouldAllowAccess) return true;
    const url: string[] = state.url.split('/').filter(urlSegment => urlSegment);

    if (url[2] === 'summary') {
      driverId = parseInt(url[3], 10);
    } else {
      driverId = parseInt(url[2], 10);
    }

    const redirectTo = `fleetview/drivers/summary/${driverId}`;
    this.router.navigate([redirectTo]);
    return false;
  }
}